const Analytics = {
	init() {
		window.addEventListener('track', (e) => {
			e.preventDefault();
			this.trackEvent({
				redirectUrl: e.detail?.redirectUrl ?? null,
				trackingEventName: e.detail?.trackingEventName,
				properties: e.detail?.properties,
				redirectTarget: e.detail?.redirectTarget ?? '_self',
			});
		});

		window.addEventListener('identify', (e) => {
			this.identifyEvent({
				memberId: e.detail?.memberId,
				properties: e.detail?.properties,
			});
		});
	},

	async trackEvent({ redirectUrl, trackingEventName, properties, redirectTarget }) {
		await window?.analytics?.track(trackingEventName, properties);
		if (redirectUrl != null) {
			this.redirect(redirectUrl, redirectTarget);
		}
	},

	identifyEvent({ memberId, properties }) {
		if (memberId !== null || memberId !== undefined || memberId !== '') {
			window?.analytics?.identify(memberId, properties);
		} else {
			window?.analytics?.identify(properties);
		}
	},

	redirect(redirectUrl, redirectTarget) {
		if (redirectTarget === '_blank') {
			window.open(redirectUrl, redirectTarget);
			return;
		}

		window.location.href = redirectUrl;
	},
};

export { Analytics as default };
